// src/pages/synthesize/components/SourceInputCard.jsx
import React from 'react';
import Icon from '../../../components/AppIcon';

const MAX_PASTE = 50000;
const MIN_PASTE_HINT = 100;

export default function SourceInputCard({ mode, onModeChange, url, onUrlChange, text, onTextChange }) {
  const tabClass = (active) =>
    `flex-1 px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
      active ? 'bg-card text-foreground' : 'text-muted-foreground hover:text-foreground'
    }`;

  return (
    <div className="space-y-3">
      <label className="block text-sm font-semibold text-foreground">Source</label>

      {/* Tabs */}
      <div className="inline-flex p-1 bg-muted rounded-lg gap-1">
        <button type="button" onClick={() => onModeChange('url')} className={tabClass(mode === 'url')}>
          <span className="inline-flex items-center gap-1.5">
            <Icon name="Link" size={13} />
            From URL
          </span>
        </button>
        <button type="button" onClick={() => onModeChange('paste')} className={tabClass(mode === 'paste')}>
          <span className="inline-flex items-center gap-1.5">
            <Icon name="ClipboardPaste" size={13} />
            Paste text
          </span>
        </button>
      </div>

      {mode === 'url' ? (
        <div>
          <input
            type="url"
            value={url}
            onChange={(e) => onUrlChange(e.target.value)}
            placeholder="https://example.com/the-article-you-just-read"
            className="w-full px-3.5 py-2.5 bg-card border border-border rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-[#A78BFA] transition-colors"
            autoComplete="off"
            spellCheck={false}
          />
          <p className="text-xs text-muted-foreground mt-1.5 flex items-center gap-1.5">
            <Icon name="Info" size={11} />
            Works on most public articles. Paywalled? Use the Paste tab.
          </p>
        </div>
      ) : (
        <div>
          <textarea
            value={text}
            onChange={(e) => onTextChange(e.target.value.slice(0, MAX_PASTE))}
            placeholder="Paste the article text, an X thread, a Reddit comment — anything you read."
            rows={8}
            className="w-full px-3.5 py-2.5 bg-card border border-border rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-[#A78BFA] transition-colors resize-y min-h-[160px]"
            spellCheck={false}
          />
          <div className="text-xs text-muted-foreground mt-1.5 flex items-center justify-between">
            <span>{text.length < MIN_PASTE_HINT ? `Paste at least ~100 words` : ' '}</span>
            <span>{text.length.toLocaleString()}/50,000</span>
          </div>
        </div>
      )}
    </div>
  );
}
